module.exports = __webpack_public_path__ + "img/approve-white.aa071083.svg";